import { Metadata } from 'next';
import { LAYOUT_OPTIONS } from '@core/config/enums';
import { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types';
import { SITE_URL } from '@/app/shared/landing/pages/landing-route-seo';

enum MODE {
  DARK = 'dark',
  LIGHT = 'light',
}

export const siteConfig = {
  title: 'Ship Smart Solutions',
  description:
    'Freight logistics admin portal for managed transportation, carrier capacity, shipment visibility, and quote workflows.',
  logo: '/shipsmart-landing/logo.svg',
  icon: '/shipsmart-landing/logo-ico.svg',
  mode: MODE.LIGHT,
  layout: LAYOUT_OPTIONS.HELIUM,
};

export const metaObject = (
  title?: string,
  openGraph?: OpenGraph,
  description: string = siteConfig.description
): Metadata => {
  return {
    title: title ?? siteConfig.title,
    description,
    openGraph: openGraph ?? {
      title: title ?? siteConfig.title,
      description,
      url: SITE_URL,
      siteName: 'Ship Smart Solutions',
      locale: 'en_US',
      type: 'website',
    },
  };
};
